import { api } from "./api";
import { PageType } from "@zotlo-shared/types/model";

export type PageViewPayload = {
  pageType: PageType;
  platform: string;
  browser: string;
  browserVersion: string;
  osName: string;
  osVersion: string;
  deviceModel: string;
  deviceVendor: string;
}

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class View {
  static get BASE_PATH() {
    if (import.meta.client) {
      return [globalThis?.location.origin || '', 'api/event'].join('/');
    }

    return 'event';
  }

  static async page(payload: PageViewPayload, headers?: Record<string, any>) {
    const route = headers ? 'pageview' : 'page';
    const response = await api.post(`${View.BASE_PATH}/${route}`, payload, headers);
    return response;
  }

  static async question(payload: {
    quizId: number;
    questionId: number;
    quizLanguage: string;
  } & PageViewPayload, headers?: Record<string, any>) {
    const route = headers ? 'quiz-question-view' : 'question';
    const response = await api.post(`${View.BASE_PATH}/${route}`, payload, headers);
    return response;
  }

  static async questionAnswer(payload: {
    quizId: number;
    questionId: number;
    answerId: string;
    quizLanguage: string;
  } & PageViewPayload, headers?: Record<string, any>) {
    const route = headers ? 'quiz-question-answer-click' : 'answer';
    const response = await api.post(`${View.BASE_PATH}/${route}`, payload, headers);
    return response;
  }
}
